import Vue from "vue";
import ElementUI from 'element-ui';
import UserCreate from '../components/UserCreate.vue';
import lang from 'element-ui/lib/locale/lang/ja';
import locale from 'element-ui/lib/locale';

locale.use(lang);
Vue.use(ElementUI);

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#user-create',
    components: { UserCreate },
  });
});
